class ScrollToTop {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.button = wrapper?.querySelector?.('.scroll-to-top') || null;
    this.showScrollThreshold = 400;
    this._raf = null;
    this.invertSelectors = [
      'footer',
      '.single-popular-posts__inner',
      '.subscribe',
    ];

    this.init();
  }

  static parseColor(value) {
    const m = value?.match?.(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)/i);
    if (!m) return null;
    return {
      r: Number(m[1]),
      g: Number(m[2]),
      b: Number(m[3]),
      a: m[4] == null ? 1 : Number(m[4]),
    };
  }

  static relativeLuminance({ r, g, b }) {
    const srgb = [r, g, b].map((v) => {
      const c = v / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  }

  static getOpaqueBackgroundColorFrom(el) {
    let node = el;
    while (node && node !== document.documentElement) {
      const style = window.getComputedStyle(node);
      const bg = ScrollToTop.parseColor(style.backgroundColor);
      if (bg && bg.a > 0.01) return bg;
      node = node.parentElement;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  shouldInvertAtPoint(x, y) {
    const list = document.elementsFromPoint?.(x, y) || [];
    for (const el of list) {
      if (el === this.wrapper || el === this.button || this.wrapper.contains(el)) continue;

      for (const selector of this.invertSelectors) {
        if (el.closest?.(selector)) return true;
      }
    }
    return false;
  }

  updateForegroundColor() {
    if (!this.button) return;

    const rect = this.button.getBoundingClientRect();
    const x = Math.round(rect.left + rect.width / 2);
    const y = Math.round(rect.top + rect.height / 2);

    const isInInvertedSection = this.shouldInvertAtPoint(x, y);
    const fg = isInInvertedSection ? '#FFFFFF' : '#000000';
    this.button.style.setProperty('--scroll-to-top-fg', fg);
  }

  scheduleUpdate() {
    if (this._raf) return;
    this._raf = window.requestAnimationFrame(() => {
      this._raf = null;
      this.updateForegroundColor();
    });
  }

  init() {
    if (!this.wrapper || !this.button) {
      return;
    }

    this.toggleScrollButton();
    this.updateForegroundColor();

    window.addEventListener('scroll', () => {
      this.toggleScrollButton();
      this.scheduleUpdate();
    }, { passive: true });
    window.addEventListener('resize', () => this.scheduleUpdate(), { passive: true });
    this.button.addEventListener('click', () => this.scrollToTop());
  }

  toggleScrollButton() {
    if (window.scrollY > this.showScrollThreshold) {
      this.wrapper.classList.add('scroll-to-top-wrap--visible');
      this.scheduleUpdate();
    } else {
      this.wrapper.classList.remove('scroll-to-top-wrap--visible');
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const scrollToTopWrap = document.querySelector('.scroll-to-top-wrap');
  if (scrollToTopWrap) {
    new ScrollToTop(scrollToTopWrap);
  }
});

